import BaseMapStore from '../store/BaseMapStore'
import ToolBarStore from '../store/ToolBarStore'
export default class RootStore {
    baseMapStore = new BaseMapStore()
    toolBarStore = new ToolBarStore()
}